export default {
      id: "oc-gpu-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-gpu",
      toString: function () {
        return this.url;
      }
    }